import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { getUUID, recordCountlyEvent } from 'utils'
import { encrypt } from 'utils/rsa'
import { getAppSalt, getCountries, getThemeVariables } from 'store/siteConfig'
import { updateAliFingerprint } from 'utils/initAliFingerprint'

// ------------------------------------
// Constants
// ------------------------------------
export const PAY_PAGE_MAIN = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    HANDLE_REQUEST: null,
    HANDLE_SUCCESS: null,
    TOGGLE_FETCH_STATUS: null,
  },
  'PAY_PAGE_MAIN'
)

// ------------------------------------
// Actions
// ------------------------------------
var record = false
export function init() {
  // sim测试商户号：200000030906
  // uat测试商户号：200000054800
  return (dispatch, getState) => {
    const orderToken = getState().siteConfig.orderToken
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          orderToken,
        },
        errControl: true,
        endpoint: 'cashierii/order/v1/unauth/init-trade',
        requestAction: PAY_PAGE_MAIN.INIT_REQUEST,
        successAction: PAY_PAGE_MAIN.INIT_SUCCESS,
        success: function(result) {
          dispatch({
            type: 'SITE_CONFIG_HANDLE_SUCCESS',
            payload: {
              payInfo: result.payInfo,
              orderNo: result.orderNo,
            },
          })
          if (!record) {
            recordCountlyEvent({
              page_name: 'cashier',
              element_name: 'pagerender',
              event_name: 'complete',
              biz_tags: {
                trade_voucher_no: result.orderNo,
                token: orderToken,
              },
            })
            record = true
          }
          sessionStorage.setItem('orderNo', result.orderNo)

          if (result.loginToken) {
            sessionStorage[orderToken] = result.loginToken
            sessionStorage[`${orderToken}-loginType`] = 'customerId'
            dispatch({
              type: 'SITE_CONFIG_HANDLE_SUCCESS',
              payload: {
                loginToken: sessionStorage[orderToken],
                loginType: 'customerId',
              },
            })
            dispatch(init())
          }
          dispatch(queryResult())
        },
      })
    )
  }
}

export function getCardToken(data, saltKey) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        header: {
          'Salt-Key': saltKey,
        },
        endpoint: 'cashierii/common/v1/unauth/cache-card-info',
        requestAction: PAY_PAGE_MAIN.HANDLE_REQUEST,
        successAction: PAY_PAGE_MAIN.HANDLE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function queryResult() {
  return (dispatch, getState) => {
    const orderToken = getState().siteConfig.orderToken
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          orderToken
        },
        errControl: true,
        hideProgress: true,
        endpoint: 'cashierii/order/v1/unauth/query-trade-result',
        requestAction: PAY_PAGE_MAIN.HANDLE_REQUEST,
        successAction: PAY_PAGE_MAIN.HANDLE_SUCCESS,
        success: function(result) {
          // 处理pay-page/main下面子路由结果查询
          if (/$\/pay-page\/main/.test(getState().router.location.pathname)) {
            return false
          }
          if (result.payResult === 'S' || result.payResult === 'F') {
            window.location.href = `/pay-page/result?orderToken=${orderToken}`
          } else {
            setTimeout(() => {
              dispatch(queryResult())
            }, 5000)
          }
        },
      })
    )
  }
}

export function payByCardToekn(data) {
  return (dispatch, getState) => {
    const orderToken = getState().siteConfig.orderToken
    const saltKey = getUUID()
    dispatch(toggleLoading(true))
      .then(() => updateAliFingerprint())
      .then((res) => dispatch(getAppSalt(saltKey)))
      .then((res) => {
        const { salt } = res.payload
        if (!salt) {
          throw new Error(' ')
        }

        const { cvv, cardNo, expireDate, holderName } = data
        return dispatch(getCardToken({
          cvv:encrypt(cvv, salt),
          expireDate:encrypt(expireDate, salt),
          holderName:encrypt(holderName, salt),
          cardNo:encrypt(cardNo.replace(/ /g, ''), salt),
          orderToken:orderToken,
        }, saltKey))
      })
      .then((res) => {
        const { cardToken } = res.payload
        if (!cardToken) {
          throw new Error(' ')
        }
        const { payInfo, payerEmail, isSaveCard } = data

        return dispatch(
          callAPI({
            dispatch: dispatch,
            method: 'POST',
            body: {
              cardToken,
              orderToken,
              payInfo,
              payerEmail,
              isSaveCard,
            },
            endpoint: 'cashierii/pay/v1/unauth/card-token-pay',
            requestAction: PAY_PAGE_MAIN.HANDLE_REQUEST,
            successAction: PAY_PAGE_MAIN.HANDLE_SUCCESS,
            success: function(result) {},
          })
        )
      })
      .then((res) => {
        const { bankForm } = res.payload
        if (!bankForm) {
          throw new Error(' ')
        }
        if (/^http/.test(bankForm)) {
          window.location.href = bankForm
          return
        }
        document.open()
        document.write(bankForm)
        document.close()
      })
      .catch((res) => {
        dispatch(toggleLoading(false))
      })
  }
}

export function payByCardId(data) {
  return (dispatch, getState) => {
    const orderToken = getState().siteConfig.orderToken
    const saltKey = getUUID()
    return dispatch(toggleLoading(true))
      .then(() => updateAliFingerprint())
      .then((res) => dispatch(getAppSalt(saltKey)))
      .then((res) => {
        const { salt } = res.payload
        if (!salt) {
          throw new Error(' ')
        }

        const { cvv, payMethodShortNo, installmentPlanId } = data
        const body = {
          orderToken,
          payMethodShortNo,
          cvv: encrypt(cvv, salt),
        }
        // Add installment plan ID if provided
        if (installmentPlanId) {
          body.installPlanId = installmentPlanId
        }
        return dispatch(
          callAPI({
            dispatch: dispatch,
            method: 'POST',
            body,
            header: {
              'Salt-Key': saltKey,
            },
            endpoint: 'cashierii/pay/v1/unauth/confirm-pay',
            requestAction: PAY_PAGE_MAIN.HANDLE_REQUEST,
            successAction: PAY_PAGE_MAIN.HANDLE_SUCCESS,
            success: function(result) {},
          })
        )
      })
      .then((res) => {
        const { bankForm } = res.payload
        if (!bankForm) {
          throw new Error(' ')
        }
        if (/^http/.test(bankForm)) {
          window.location.href = bankForm
          return
        }
        document.open()
        document.write(bankForm)
        document.close()
      })
      .catch((res) => {
        dispatch(toggleLoading(false))
      })
  }
}

export function applePayValidateURL(data) {
  return (dispatch, getState) => {
    const orderToken = getState().siteConfig.orderToken
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          orderToken,
          ...data,
        },
        endpoint: 'cashierii/pay/v1/unauth/init',
        requestAction: PAY_PAGE_MAIN.HANDLE_REQUEST,
        successAction: PAY_PAGE_MAIN.HANDLE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function payByDevice(data) {
  return (dispatch, getState) => {
    const orderToken = getState().siteConfig.orderToken
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          orderToken,
          ...data,
        },
        endpoint: 'cashierii/pay/v1/unauth/confirm-pay',
        requestAction: PAY_PAGE_MAIN.HANDLE_REQUEST,
        successAction: PAY_PAGE_MAIN.HANDLE_SUCCESS,
        success: function(result) {
          window.location.replace(
            `/pay-page/result?orderToken=${orderToken}`
          )
        },
      })
    )
  }
}

export function toggleLoading(isLoading) {
  return (dispatch) => {
    dispatch({
      type: PAY_PAGE_MAIN.TOGGLE_FETCH_STATUS,
      payload: {
        loading: isLoading,
      },
    })
    return Promise.resolve()
  }
}

export function deleteCard(data) {
  return (dispatch, getState) => {
    const loginToken = getState().siteConfig.loginToken
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          ...data,
          loginToken,
        },
        endpoint: 'cashierii/order/v1/unauth/delete-pay-method',
        requestAction: PAY_PAGE_MAIN.HANDLE_REQUEST,
        successAction: PAY_PAGE_MAIN.HANDLE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAY_PAGE_MAIN.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAY_PAGE_MAIN.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAY_PAGE_MAIN.TOGGLE_FETCH_STATUS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAY_PAGE_MAIN.HANDLE_REQUEST]: (state, action) => state,
  [PAY_PAGE_MAIN.HANDLE_SUCCESS]: (state, action) => state,
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: true
}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'payPageMain',
    reducerMap: {
      payPageMainState: reducer,
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    initialActions: [getThemeVariables(), getCountries()],
    // finalActions: []
  }
}
